import React from "react";
import "./ButtonStyle.css";
import "./LabelIconButtonStyle.css";

const LabelIconButton = ({
  className,
  value,
  onClickLabel,
  indicatorIcon,
  display_text,
}) => {
  return (
    <button
      className={className + " default"}
      value={value}
      onClick={onClickLabel}
    >
      {indicatorIcon}
      {display_text}
    </button>
  );
};

export default LabelIconButton;
